/* Footer wordmark (sections/chumzy-wordmark.liquid): fit the word to the column width exactly, so it is never cut. */
(() => {
  const fitAll = () => {
    document.querySelectorAll('[data-cz-fit]').forEach((word) => {
      const box = word.parentElement.clientWidth;
      word.style.fontSize = '100px';
      const w = word.getBoundingClientRect().width;
      if (w > 0) word.style.fontSize = `${Math.floor(((100 * box) / w) * 10) / 10}px`;
    });
  };
  document.querySelectorAll('[data-cz-fit]').forEach((word) => new ResizeObserver(fitAll).observe(word.parentElement));
  if (document.fonts) document.fonts.ready.then(fitAll);
  fitAll();
})();
